import { fa_danthuoc } from '../../models/response/y-te/fa_danthuoc';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_DAN_THUOC_PATH = 'dan-thuoc';

class DanThuocApi extends BaseCRUDApi<fa_danthuoc> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	/** LƯU Ý: adm viết sai url này (`co-so/\${id}}` — thừa 1 dấu `}`), bản này đã sửa. */
	SelectAllByCoSo(dm_coso_id: number) {
		return apiClient.get(`${API_DAN_THUOC_PATH}/co-so/${dm_coso_id}`);
	}
	/** Backend nhận `List<int>` (danh sách id đơn thuốc), KHÔNG phải `DanThuocItemRequest`. */
	CapNhatXuLy(ids: number[]) {
		return apiClient.put(`${API_DAN_THUOC_PATH}/capnhat-xuly`, ids);
	}
	/** Backend nhận `List<int>` (danh sách id đơn thuốc), KHÔNG phải `DanThuocItemRequest`. */
	CapNhatChuaXuLy(ids: number[]) {
		return apiClient.put(`${API_DAN_THUOC_PATH}/capnhat-chuaxuly`, ids);
	}
}
export const danThuocApi = new DanThuocApi(API_DAN_THUOC_PATH);
